
const CELL_WIDTH = 20;
const CELL_HEIGHT = 40;
const CONTAINER_WIDTH = 40;
const CONTAINER_HEIGHT = 40;
const SHIP_BORDER = 3;
const BACK_WIDTH = 52;
const FRONT_WIDTH = 30;



export {
	CELL_WIDTH,
	CELL_HEIGHT,
	CONTAINER_WIDTH,
	CONTAINER_HEIGHT,
	SHIP_BORDER,
	BACK_WIDTH,
	FRONT_WIDTH,
}